export const reportError = (error: Error | null, errorInfo: object) => {
  console.log(error);
  console.log(errorInfo);
};
